import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import { Credential } from '../classes/credential';
import { AlertService } from './alert.service';

@Injectable()
export class LoginService {
  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private commonService: CommonService
  ) { }

  login(UserName: string, Password: string): Promise<any> {
    const credential: Credential = new Credential(UserName, Password);
    // var param = { 'UserName' : UserName, 'Password' : Password };
    return this.http.post(this.commonService.getPrefixUrlService() + 'Service.svc/validateUser',
      JSON.stringify(credential), {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        console.log('response response response : ', response)
        if ( response && response['status'] && response['status'] === 'EXITO' ) {
          console.log('login.service.then.exito: ', response['mensaje']);
          localStorage.setItem('currentUser', JSON.stringify(response));
        } else {
          if (response && response['message']) {
            this.alertService.error(response['message']);
            console.log('login.service.then.error: ', response['message']);
          } else {
            this.alertService.error('error')
            console.log('error ');
          }
        }
        return response;
      });
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
  }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/services/login.service.ts